import type { UseFormReturn } from 'react-hook-form';
import { Checkbox, Disclosure, DisclosureButton, Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type IArticleFormAdvancedOptionsSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
};

export const ArticleFormAdvancedOptionsSection: React.FC<
  IArticleFormAdvancedOptionsSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <Disclosure
      sx={sx}
      trigger={
        <DisclosureButton>{t('common.advanced-options')}</DisclosureButton>
      }
    >
      <FormSection sub>
        <Labeled
          label={t('ArticleFormAdvancedOptionsSection.field.pin-article.label')}
          supportingText={t(
            'ArticleFormAdvancedOptionsSection.field.pin-article.supporting-text',
          )}
          labelPosition="right"
        >
          <FormField name="pinned" control={form.control} as={Checkbox} />
        </Labeled>
        <Labeled
          label={t('ArticleFormAdvancedOptionsSection.field.fullscreen.label')}
          labelPosition="right"
        >
          <FormField name="fullscreen" control={form.control} as={Checkbox} />
        </Labeled>
        <Labeled
          label={t('ArticleFormAdvancedOptionsSection.field.raw-content.label')}
          labelPosition="right"
        >
          <FormField name="rawContent" control={form.control} as={Checkbox} />
        </Labeled>
        <Labeled
          label={t(
            'ArticleFormAdvancedOptionsSection.field.hideFromFeed.label',
          )}
          supportingText={t(
            'ArticleFormAdvancedOptionsSection.field.hideFromFeed.supportingText',
          )}
          labelPosition="right"
        >
          <FormField name="hideFromFeed" control={form.control} as={Checkbox} />
        </Labeled>
        <Labeled
          label={t(
            'ArticleFormAdvancedOptionsSection.field.hide-comments.label',
          )}
          labelPosition="right"
        >
          <FormField name="hideComments" control={form.control} as={Checkbox} />
        </Labeled>
        <Labeled
          label={t(
            'ArticleFormAdvancedOptionsSection.field.hide-share-buttons.label',
          )}
          labelPosition="right"
        >
          <FormField
            name="hideShareButtons"
            control={form.control}
            as={Checkbox}
          />
        </Labeled>
      </FormSection>
    </Disclosure>
  );
};
